export const submissionCode = '<script type="text/javascript">\n' +
	'\tvar form = document.forms[0]; //Change this to correspond to your form. The form\'s submit button cannot be called "submit"\n' +
	'\tform.addEventListener("submit", function(e) {\n' +
	'\t\te.preventDefault(); //Intercept form submit and run SaveWidget()\n' +
	'\t\tSaveWidget(\'$preferenceWidgetId\', \'$accessKey\', \'$preferenceWidgetDivId\');\n' +
	'\t});\n' +
	'\n' +
	'\tfunction SaveWidget(FormID, LicenseID, DivID) {\n' +
	'\t\tvar PostURL = \'$widgetApiSubmit\';\n' +
	'\t\tif (window.cassieResourceRootDomain != null) {\n' +
	'\t\t\tPostURL = PostURL.replace("cassiecloud.com", window.cassieResourceRootDomain)\n' +
	'\t\t}\n' +
	'\t\tvar ObjectArray = []; // Define an empty Object Array\n' +
	'\t\tvar RecordObject = {}; // Define an empty Record Object for holding data\n' +
	'\t\t/*\n' +
	'\t\t * Forename, Surname and Email1 are required fields within the RecordObject,\n' +
	'\t\t * the remaining fields are optional and need not be defined at all unless\n' +
	'\t\t * you plan to use them.\n' +
	'\t\t */\n' +
	'\t\t//*** Scrape form fields for matching ***//\n' +
	'\t\tRecordObject.DivID = DivID; // This is the name of the container that holds the Cassie widget.\n' +
	'\t\tRecordObject.LanguageCode = cassieWidgetLanguageCode;\n' +
	'\t\tif (document.getElementsByName("title")[0] != undefined) {\n' +
	'\t\t\tRecordObject.Title = document.getElementsByName("title")[0].value;\n' +
	'\t\t} else {\n' +
	'\t\t\tRecordObject.Title = "";\n' +
	'\t\t}\n' +
	'\t\tif (document.getElementsByName("forename")[0] != undefined) {\n' +
	'\t\t\tRecordObject.Forename = document.getElementsByName("forename")[0].value;\n' +
	'\t\t} else {\n' +
	'\t\t\tRecordObject.Forename = "";\n' +
	'\t\t}\n' +
	'\t\tif (document.getElementsByName("middlename")[0] != undefined) {\n' +
	'\t\t\tRecordObject.MiddleName = document.getElementsByName("middlename")[0].value;\n' +
	'\t\t} else {\n' +
	'\t\t\tRecordObject.MiddleName = "";\n' +
	'\t\t}\n' +
	'\t\tif (document.getElementsByName("surname")[0] != undefined) {\n' +
	'\t\t\tRecordObject.Surname = document.getElementsByName("surname")[0].value;\n' +
	'\t\t} else {\n' +
	'\t\t\tRecordObject.Surname = "";\n' +
	'\t\t}\n' +
	'\t\tif (document.getElementsByName("email1")[0] != undefined) {\n' +
	'\t\t\tRecordObject.Email1 = document.getElementsByName("email1")[0].value;\n' +
	'\t\t\tRecordObject.Email1 = encodeURIComponent(RecordObject.Email1);\n' +
	'\t\t} else {\n' +
	'\t\t\tRecordObject.Email1 = "";\n' +
	'\t\t}\n' +
	'\t\tif (document.getElementsByName("email2")[0] != undefined) {\n' +
	'\t\t\tRecordObject.Email2 = document.getElementsByName("email2")[0].value;\n' +
	'\t\t} else {\n' +
	'\t\t\tRecordObject.Email2 = "";\n' +
	'\t\t}\n' +
	'\t\tif (document.getElementsByName("telephone1")[0] != undefined) {\n' +
	'\t\t\tRecordObject.Telephone1 = document.getElementsByName("telephone1")[0].value;\n' +
	'\t\t} else {\n' +
	'\t\t\tRecordObject.Telephone1 = "";\n' +
	'\t\t}\n' +
	'\t\tif (document.getElementsByName("telephone2")[0] != undefined) {\n' +
	'\t\t\tRecordObject.Telephone2 = document.getElementsByName("telephone2")[0].value;\n' +
	'\t\t} else {\n' +
	'\t\t\tRecordObject.Telephone2 = "";\n' +
	'\t\t}\n' +
	'\t\tif (document.getElementsByName("mobile")[0] != undefined) {\n' +
	'\t\t\tRecordObject.Mobile = document.getElementsByName("mobile")[0].value;\n' +
	'\t\t} else {\n' +
	'\t\t\tRecordObject.Mobile = "";\n' +
	'\t\t}\n' +
	'\t\tif (document.getElementsByName("address1")[0] != undefined) {\n' +
	'\t\t\tRecordObject.Address1 = document.getElementsByName("address1")[0].value;\n' +
	'\t\t} else {\n' +
	'\t\t\tRecordObject.Address1 = "";\n' +
	'\t\t}\n' +
	'\t\tif (document.getElementsByName("address2")[0] != undefined) {\n' +
	'\t\t\tRecordObject.Address2 = document.getElementsByName("address2")[0].value;\n' +
	'\t\t} else {\n' +
	'\t\t\tRecordObject.Address2 = "";\n' +
	'\t\t}\n' +
	'\t\tif (document.getElementsByName("address3")[0] != undefined) {\n' +
	'\t\t\tRecordObject.Address3 = document.getElementsByName("address3")[0].value;\n' +
	'\t\t} else {\n' +
	'\t\t\tRecordObject.Address3 = "";\n' +
	'\t\t}\n' +
	'\t\tif (document.getElementsByName("address4")[0] != undefined) {\n' +
	'\t\t\tRecordObject.Address4 = document.getElementsByName("address4")[0].value;\n' +
	'\t\t} else {\n' +
	'\t\t\tRecordObject.Address4 = "";\n' +
	'\t\t}\n' +
	'\t\tif (document.getElementsByName("address5")[0] != undefined) {\n' +
	'\t\t\tRecordObject.Address5 = document.getElementsByName("address5")[0].value;\n' +
	'\t\t} else {\n' +
	'\t\t\tRecordObject.Address5 = "";\n' +
	'\t\t}\n' +
	'\t\tif (document.getElementsByName("town")[0] != undefined) {\n' +
	'\t\t\tRecordObject.Town = document.getElementsByName("town")[0].value;\n' +
	'\t\t} else {\n' +
	'\t\t\tRecordObject.Town = "";\n' +
	'\t\t}\n' +
	'\t\tif (document.getElementsByName("county")[0] != undefined) {\n' +
	'\t\t\tRecordObject.County = document.getElementsByName("county")[0].value;\n' +
	'\t\t} else {\n' +
	'\t\t\tRecordObject.County = "";\n' +
	'\t\t}\n' +
	'\t\tif (document.getElementsByName("postcode")[0] != undefined) {\n' +
	'\t\t\tRecordObject.Postcode = document.getElementsByName("postcode")[0].value;\n' +
	'\t\t} else {\n' +
	'\t\t\tRecordObject.Postcode = "";\n' +
	'\t\t}\n' +
	'\t\tif (document.getElementsByName("country")[0] != undefined) {\n' +
	'\t\t\tRecordObject.Country = document.getElementsByName("country")[0].value;\n' +
	'\t\t} else {\n' +
	'\t\t\tRecordObject.Country = "";\n' +
	'\t\t}\n' +
	'\t\tif (document.getElementsByName("campaigncode")[0] != undefined) {\n' +
	'\t\t\tRecordObject.CampaignCode = document.getElementsByName("campaigncode")[0].value;\n' +
	'\t\t} else {\n' +
	'\t\t\tRecordObject.CampaignCode = "";\n' +
	'\t\t}\n' +
	'\t\tif (document.getElementsByName("sourcecode")[0] != undefined) {\n' +
	'\t\t\tRecordObject.SourceCode = document.getElementsByName("sourcecode")[0].value;\n' +
	'\t\t} else {\n' +
	'\t\t\tRecordObject.SourceCode = "";\n' +
	'\t\t}\n' +
	'\t\tif (document.getElementsByName("responsechannel")[0] != undefined) {\n' +
	'\t\t\tRecordObject.ResponseChannel = document.getElementsByName("responsechannel")[0].value;\n' +
	'\t\t} else {\n' +
	'\t\t\tRecordObject.ResponseChannel = "";\n' +
	'\t\t}\n' +
	'\t\tif (document.getElementsByName("urn1")[0] != undefined) {\n' +
	'\t\t\tRecordObject.Urn1 = document.getElementsByName("urn1")[0].value;\n' +
	'\t\t} else {\n' +
	'\t\t\tRecordObject.Urn1 = "";\n' +
	'\t\t}\n' +
	'\t\tif (document.getElementsByName("urn2")[0] != undefined) {\n' +
	'\t\t\tRecordObject.Urn2 = document.getElementsByName("urn2")[0].value;\n' +
	'\t\t} else {\n' +
	'\t\t\tRecordObject.Urn2 = "";\n' +
	'\t\t}\n' +
	'\t\tif (document.getElementsByName("urn3")[0] != undefined) {\n' +
	'\t\t\tRecordObject.Urn3 = document.getElementsByName("urn3")[0].value;\n' +
	'\t\t} else {\n' +
	'\t\t\tRecordObject.Urn3 = "";\n' +
	'\t\t}\n' +
	'\t\tif (document.getElementsByName("custom1")[0] != undefined) {\n' +
	'\t\t\tRecordObject.Custom1 = document.getElementsByName("custom1")[0].value;\n' +
	'\t\t} else {\n' +
	'\t\t\tRecordObject.Custom1 = "";\n' +
	'\t\t}\n' +
	'\t\tif (document.getElementsByName("custom2")[0] != undefined) {\n' +
	'\t\t\tRecordObject.Custom2 = document.getElementsByName("custom2")[0].value;\n' +
	'\t\t} else {\n' +
	'\t\t\tRecordObject.Custom2 = "";\n' +
	'\t\t}\n' +
	'\t\tif (document.getElementsByName("custom3")[0] != undefined) {\n' +
	'\t\t\tRecordObject.Custom3 = document.getElementsByName("custom3")[0].value;\n' +
	'\t\t} else {\n' +
	'\t\t\tRecordObject.Custom3 = "";\n' +
	'\t\t}\n' +
	'\t\tif (document.getElementsByName("custom4")[0] != undefined) {\n' +
	'\t\t\tRecordObject.Custom4 = document.getElementsByName("custom4")[0].value;\n' +
	'\t\t} else {\n' +
	'\t\t\tRecordObject.Custom4 = "";\n' +
	'\t\t}\n' +
	'\t\tif (document.getElementsByName("custom5")[0] != undefined) {\n' +
	'\t\t\tRecordObject.Custom5 = document.getElementsByName("custom5")[0].value;\n' +
	'\t\t} else {\n' +
	'\t\t\tRecordObject.Custom5 = "";\n' +
	'\t\t}\n' +
	'\t\tif (document.getElementsByName("custom6")[0] != undefined) {\n' +
	'\t\t\tRecordObject.Custom6 = document.getElementsByName("custom6")[0].value;\n' +
	'\t\t} else {\n' +
	'\t\t\tRecordObject.Custom6 = "";\n' +
	'\t\t}\n' +
	'\t\tif (document.getElementsByName("custom7")[0] != undefined) {\n' +
	'\t\t\tRecordObject.Custom7 = document.getElementsByName("custom7")[0].value;\n' +
	'\t\t} else {\n' +
	'\t\t\tRecordObject.Custom7 = "";\n' +
	'\t\t}\n' +
	'\t\tif (document.getElementsByName("custom8")[0] != undefined) {\n' +
	'\t\t\tRecordObject.Custom8 = document.getElementsByName("custom8")[0].value;\n' +
	'\t\t} else {\n' +
	'\t\t\tRecordObject.Custom8 = "";\n' +
	'\t\t}\n' +
	'\t\tif (document.getElementsByName("custom9")[0] != undefined) {\n' +
	'\t\t\tRecordObject.Custom9 = document.getElementsByName("custom9")[0].value;\n' +
	'\t\t} else {\n' +
	'\t\t\tRecordObject.Custom9 = "";\n' +
	'\t\t}\n' +
	'\t\tif (document.getElementsByName("custom10")[0] != undefined) {\n' +
	'\t\t\tRecordObject.Custom10 = document.getElementsByName("custom10")[0].value;\n' +
	'\t\t} else {\n' +
	'\t\t\tRecordObject.Custom10 = "";\n' +
	'\t\t}\n' +
	'\t\t//If we have a cookie preference already saved for this record, then add it to the record object for processing\n' +
	'\t\tvar deviceGUID = document.cookie.replace(/(?:(?:^|.*;\\s*)SyrenisGuid_.+?\\s*\\=\\s*([^;]*).*$)|^.*$/, "$1");\n' +
	'\t\tif (deviceGUID != "") {\n' +
	'\t\t\tRecordObject.DeviceGUID = deviceGUID;\n' +
	'\t\t}\n' +
	'$privacyPolicySubmissionCode' +
	'\t\t//*** Process preferences ***//\n' +
	'\t\t// Add preferences to RecordObject, and RecordObject to ObjectArray\n' +
	'\t\tRecordObject.Preferences = GetPreferencesArray();\n' +
	'\t\tObjectArray.push(RecordObject);\n' +
	'\t\tRecordObject.FormID = FormID;\n' +
	'\t\tRecordObject.LicenseID = LicenseID;\n' +
	'\t\t//Log values\n' +
	'\t\t//console.log("PostURL=" + PostURL);\n' +
	'\t\t//console.log("RecordObject = " + JSON.stringify(RecordObject));\n' +
	'\t\t// Post the data to the Cassie web service\n' +
	'\t\tvar xmlhttp = new XMLHttpRequest();\n' +
	'\t\txmlhttp.open("POST", PostURL, true);\n' +
	'\t\txmlhttp.setRequestHeader("Content-type", "application/json");\n' +
	'\t\txmlhttp.onreadystatechange = function() {\n' +
	'\t\t\tif (xmlhttp.readyState === 4) {\n' +
	'\t\t\t\tif (xmlhttp.status === 200) {\n' +
	'\t\t\t\t\t//Submit form as usual\n' +
	'\t\t\t\t\tform.submit();\n' +
	'\t\t\t\t}\n' +
	'\t\t\t}\n' +
	'\t\t}\n' +
	'\t\tvar JSONRecordObject = JSON.stringify(RecordObject);\n' +
	'\t\txmlhttp.send(JSONRecordObject);\n' +
	'\t};\n' +
	'</script>\n'

export const widgetEmbedCode2 = '<script src="$widgetUrl"></script>\n' +
	'<script type="text/javascript">\n' +
	'document.addEventListener("DOMContentLoaded", function (event) {\n' +
	'\tGetWidget("$preferenceWidgetId", "$licenceKey", "$accessKey", "$preferenceWidgetDivId", "$optionAppearance" ,"$language")\n' +
	'\tvar CookieConsentID = checkCookie("CookieConsentID")\n' +
	'});\n' +
	'</script>\n'

export const privacyPolicySubmissionCode = '\t\t//Add privacy policy ID and privacy policy version ID\n' +
'\t\tvar container = document.getElementById(DivID);\n' +
'\t\tvar privacyPolicyId = container.getAttribute("privacy-policy-id");\n' +
'\t\tif (privacyPolicyId && !!privacyPolicyId.length) {\n' +
'\t\t\tRecordObject.PrivacyPolicyID = privacyPolicyId;\n' +
'\t\t}\n' +
'\t\tvar privacyPolicyVersionId = container.getAttribute("privacy-policy-version-id");\n' +
'\t\tif (privacyPolicyVersionId && !!privacyPolicyVersionId.length) {\n' +
'\t\t\tRecordObject.PrivacyPolicyVersionID = privacyPolicyVersionId;\n' +
'\t\t}\n'

export const widgetEmbedCode2Dynamic = '<script>\n' +
	'\tfunction getRootDomain(url) {\n' +
	'\t\ttry {\n' +
	'\t\t\tconst domain = new URL(url).hostname;\n' +
	'\t\t\tconst elems = domain.split(".");\n' +
	'\t\t\tconst iMax = elems.length - 1;\n' +
	'\t\t\tconst isSecondLevel = elems.length >= 3 && (elems[iMax] + elems[iMax - 1]).length <= 5;\n' +
	'\t\t\treturn elems.splice(isSecondLevel ? -3 : -2).join(".");\n' +
	'\t\t} catch (error) {\n' +
	'\t\t\treturn null;\n' +
	'\t\t}\n' +
	'\t}\n' +
	'\n' +
	'\tfunction loadScript(src, onSuccess, onError) {\n' +
	'\t\tconst script = document.createElement(\'script\');\n' +
	'\t\tscript.src = src;\n' +
	'\t\tscript.onload = () => {\n' +
	'\t\t\tif (onSuccess) onSuccess();\n' +
	'\t\t};\n' +
	'\t\t	script.onerror = () => {\n' +
	'\t\t\tif (onError) onError();\n' +
	'\t\t};\n' +
	'\t\tdocument.head.appendChild(script);\n' +
	'\t}\n' +
	'\n' +
	'\tfunction initCassieWidget() {\n' +
	'\t\twindow.onload = function() {\n' +
	'\t\t\tGetWidget("$preferenceWidgetId", "$licenceKey", "$accessKey", "$preferenceWidgetDivId", "$optionAppearance" ,"$language")\n' +
	'\t\t\tvar CookieConsentID = checkCookie("CookieConsentID")\n' +
	'\t\t};\n' +
	'\t}\n' +
	'\n' +
	'\tfunction loadScriptWithFallback() {\n' +
	'\t\tconst rootDomain = getRootDomain(window.location.href);\n' +
	'\t\tlet scriptUrl = rootDomain ? `$dynamicWidgetUrl` : \'$widgetUrl\';\n' +
	'\t\twindow.cassieResourceRootDomain = rootDomain;\n' +
	'\n' +
	'\t\tloadScript(scriptUrl, () => {\n' +
	'\t\t\tinitCassieWidget();\n' +
	'\t\t}, () => {\n' +
	'\t\t\twindow.cassieResourceRootDomain = null;\n' +
	'\t\t\tloadScript(\'$widgetUrl\', () => {\n' +
	'\t\t\t\tinitCassieWidget();\n' +
	'\t\t\t});\n' +
	'\t\t});\n' +
	'\t}\n' +
	'\n' +
	'\tloadScriptWithFallback();\n' +
	'</script>'
